<template>
  <div class="carAccidentListCom">
    <img src="@/assets/images/list/ang1.png" :class="ang1" />
    <img src="@/assets/images/list/ang2.png" :class="ang2" />
    <img src="@/assets/images/list/ang2.png" class="ang2-2" />
    <img src="@/assets/images/list/ang3.png" class="ang3" />
    <img src="@/assets/images/list/ang4.png" class="ang4" />
    <div class="maincontent">
      <div class="changlistbtns">
        <div :class="commonBts1" @click="isAllList(false)">
          <span class="cn-title title-selected">今日理赔</span>
          <span :class="enTitle1">Today‘s settlement</span>
        </div>
        <div :class="commonBts2" @click="isAllList(true)">
          <span class="cn-title">全部理赔</span>
          <span :class="enTitle2">All settlement</span>
        </div>
      </div>
      <div class="listcontent">
        <div class="searchform" v-if="allList">
          <div class="searchitem1">
            <span class="searchitem1-laber">车辆救援编号</span>
            <el-input class="searchinput" v-model.trim="query.code"></el-input>
            <span class="searchitem1-laber">接警电话</span>
            <el-input v-model.trim="query.reportPhone"></el-input>
          </div>
          <div class="searchitem1">
            <span class="searchitem1-laber">事故编号</span>
            <el-input v-model.trim="query.accidentId"></el-input>
            <span class="searchitem1-laber">事故状态</span>
            <dict-select v-model="query.status" type="accident_status" />
          </div>
          <div class="searchitem1">
            <span class="searchitem1-laber">事故车牌</span>
            <el-input v-model.trim="query.carLicenseNum"></el-input>
            <span class="searchitem1-laber">理赔状态</span>
            <el-select v-model="query.claim" placeholder="请选择">
              <el-option label="已理赔" :value="true"> </el-option>
              <el-option label="未理赔" :value="false"> </el-option>
            </el-select>
          </div>
          <div class="searchitem1 searchitem2">
            <span class="searchitem1-laber">事故时刻</span>
            <!-- <el-date-picker
              v-model="accidentDate"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              range-separator="至"
            /> -->
            <div class="timepicker">
              <el-date-picker
                v-model="query.accidentStartDate"
                type="datetime"
                placeholder="选择开始时间"
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                :time-arrow-control='false'>
              </el-date-picker>
              <el-date-picker
                v-model="query.accidentEndDate"
                type="datetime"
                placeholder="选择结束时间"
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                :time-arrow-control='false'>
              </el-date-picker>

            </div>
            <span class="searchitem1-laber"></span>
            <div class="searchbtns">
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search-btn"
                @click="search"
                >搜索</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-refresh"
                class="reset-btn"
                @click="reset"
                >重置</el-button
              >
            </div>
          </div>
        </div>
        <el-table
          :data="tableData"
          v-on="$listeners"
          v-bind="$attrs"
          row-key="id"
          v-loading="loading"
          @selection-change="$emit('update:selectedAccidents', $event)"
          :header-cell-style="{
            background: 'rgba(2, 133, 216, 0.1)',
            color: '#7CAFFF',
            fontWeight: 100,
          }"
        >
          <el-table-column type="selection" align="center" v-if="selectedAccidents" />
          <!-- <div>
        <div v-for="(item, index) in formValues" :key="index">
          <el-table-column :label="item" :prop="formKeys[index]"></el-table-column>
        </div>
      </div> -->

          <el-table-column
            class-name="orderNumber"
            type="index"
            label="序号"
          ></el-table-column>
          <el-table-column label="车辆救援编号" prop="code"></el-table-column>
          <el-table-column label="关联事故编号" prop="accidentId"></el-table-column>
          <el-table-column
            label="事故地点"
            min-width="200px"
            prop="accidentAddress"
          ></el-table-column>
          <el-table-column label="事故时间" prop="accidentTime"></el-table-column>
          <el-table-column label="驾驶人姓名" prop="driverName"></el-table-column>
          <el-table-column label="车牌号" prop="carLicenseNum"></el-table-column>
          <el-table-column label="车辆清单" prop="maintenanceListUrl">
            <template #default="{ row: { maintenanceListUrl } }" }>
              <span v-if="maintenanceListUrl">
                <el-icon name="success" class="text-success"></el-icon>
                已上传
              </span>
              <span v-else>
                <el-icon name="remove" class="text-danger"></el-icon>
                未上传
              </span>
            </template>
          </el-table-column>
          <el-table-column label="事故状态" prop="status">
            <template #default="{ row: { status } }" }>
              <span v-if="status">
                <el-icon name="success" class="text-success"></el-icon>
                已定责
              </span>
              <span v-else>
                <el-icon name="remove" class="text-danger"></el-icon>
                未定责
              </span>
            </template>
          </el-table-column>
          <el-table-column label="费用信息" prop="totalCost">
            <template slot-scope="scope">
              <span>{{
                scope.row.claim === 1
                  ? "已结清"
                  : scope.row.claim === 2
                  ? "部分结清"
                  : "未结清"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="理赔" prop="claim">
            <template #default="{ row: { claim } }" }>
              <span v-if="claim">
                <el-icon name="success" class="text-success"></el-icon>
                已理赔
              </span>
              <span v-else>
                <el-icon name="remove" class="text-danger"></el-icon>
                未理赔
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px">
            <div
              class="operator-group"
              slot-scope="{
                row: {
                  accidentId,
                  liability,
                  claim,
                  carMaintainStatus,
                  status,
                  upload,
                  code,
                  statementUrl,
                  accidentPartyList,
                  caseDealType,
                  id,
                },
              }"
            >
              <el-link
                @click="
                  $router.push({
                    name: 'AccidentEdit',
                    params: { id: accidentId, detailId: id },
                  })
                "
                >查看</el-link
              >
              <template>
                <el-link
                  v-if="
                    !liability &&
                    ((currentRole === '交警' && caseDealType && caseDealType === 2) ||
                      isAdmin ||
                      (currentRole === '坐席' && caseDealType && caseDealType === 1))
                  "
                  @click="
                    () => {
                      currentAccidentId = accidentId;
                      liabilityVisible = true;
                    }
                  "
                  >定责
                </el-link>

                <el-link
                  v-if="currentRole === '保险员' || isAdmin"
                  @click="
                    () => {
                      currentAccidentId = accidentId;
                      claimVisible = true;
                    }
                  "
                  >理赔
                </el-link>
              </template>
              <el-link
                type="primary"
                v-if="!upload && currentRole === '坐席'"
                @click="
                  () => {
                    currentAccidentId = accidentId;
                    currentStatementUrl = statementUrl;
                    uploadVisible = true;
                  }
                "
              >
                上传
              </el-link>
              <el-link @click="openRepairModal(carMaintainStatus, id)">
                修车进度
              </el-link>
              <el-link @click="openDirectCompensation(claim, id)">
                直赔进度
              </el-link>
            </div>
          </el-table-column>
        </el-table>
        <pagination
          :total="pagination.total"
          layout="total, prev, pager, next"
          :page.sync="pagination.page"
          :limit.sync="pagination.size"
          @pagination="changeCurrentPage"
        />
      </div>
    </div>
    <liability
      :accidentId="currentAccidentId"
      :visible.sync="liabilityVisible"
      @ok="$emit('refresh')"
    />
    <claim
      :accidentId="currentAccidentId"
      :visible.sync="claimVisible"
      @ok="$emit('refresh')"
    />
    <!-- <el-dialog
      :visible.sync="uploadVisible"
      center
      title="上传事故认定书"
      destroy-on-close
    >
      <upload-statement
        :accidentId="currentAccidentId"
        :statementUrl.sync="currentStatementUrl"
      />
      <template #footer>
        <el-button
          @click="
            () => {
              uploadVisible = false;
              $emit('getUserInfoToShow');
            }
          "
          type="primary"
          >确定</el-button
        >
      </template>
    </el-dialog> -->
    <myDialog
      :logTitle="'上传事故认定书'"
      :logHeight="'380px'"
      :showDialog.sync="uploadVisible"
    >
      <upload-statement
        :accidentId="currentAccidentId"
        :statementUrl.sync="currentStatementUrl"
      />
      <template #footer>
        <el-button
          @click="
            () => {
              uploadVisible = false;
              $emit('getUserInfoToShow');
            }
          "
          type="primary"
          >确定</el-button
        >
      </template>
    </myDialog>
    <myDialog
      :logTitle="'修改修车进度'"
      :logHeight="'380px'"
      :showDialog.sync="repairProcessVisible"
    >
      <div class="processcontent">
        <div class="process">
          <el-checkbox
            v-model="process1"
            :checked="process1Checked"
            :disabled="process1Disabled"
            >已受理</el-checkbox
          >
          <el-checkbox
            v-model="process2"
            :checked="process2Checked"
            :disabled="process2Disabled"
            >处理中</el-checkbox
          >
          <el-checkbox
            v-model="process3"
            :checked="process3Checked"
            :disabled="process3Disabled"
            >已完成</el-checkbox
          >
        </div>
        <div class="proBtns">
          <div class="proCancle" @click="processCancle">取消</div>
          <div class="proConfire" @click="processConfire">确认</div>
        </div>
      </div>
    </myDialog>
    
  </div>
</template>

<script>
import Liability from "@/views/accident/components/Liability";
import Claim from "@/views/accident/components/Claim";
import UploadStatement from "@/views/accident/components/UploadStatement.vue";
import { commonAccidentList } from "@/views/accidentList.js";
import DictSelect from "@/views/accident/components/dict-select.vue";
import { req, getCarRescueList } from "@/api/accident/list";
import myDialog from "@/components/custom/myDialog.vue";
export default {
  name: "carAccidentListCom",
  components: { Liability, Claim, UploadStatement, DictSelect, myDialog },
  props: {
    // source: {
    //   type: Object,
    //   default: () => commonAccidentList
    // },
    selectedAccidents: {
      type: Array,
      required: false,
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 10,
        total: 0,
      }),
    },
  },
  computed: {
    currentRole() {
      console.log(this.$store.getters.accidentRoleName);
      return this.$store.getters.accidentRoleName;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  data() {
    return {
      currentAccidentId: "",
      liabilityVisible: false,
      claimVisible: false,
      uploadVisible: false,
      repairProcessVisible: false,
      currentStatementUrl: "",
      dictMap: { accident_status: {}, case_deal_type: {} },
      formKeys: [],
      tableData: [],
      formValues: [],
      commonBts1: "commonbtn selectedbtn",
      commonBts2: "commonbtn",
      enTitle1: "english-title en-selected",
      enTitle2: "english-title",
      ang1: "ang1",
      ang2: "ang2",
      allList: false,
      loading: false,
      statusBtns1: "status1 status-selected",
      statusBtns2: "status2",
      statusBtns3: "status2",
      query: {
        accidentId: "",
        accidentStartDate: "",
        accidentEndDate: "",
        claim: "",
      },
      accidentDate: "",
      carMaintainStatus1: "",
      code1: "",
      process1: "",
      process2: "",
      process3: "",
      process1Checked: false,
      process2Checked: false,
      process3Checked: false,
      process1Disabled: false,
      process2Disabled: false,
      process3Disabled: false,
    };
  },

  mounted() {
    this.query = this.$store.getters.searchCondition.isSearch ? this.$store.getters.searchCondition.searchQuery : { status: '' }
    let status = this.$store.getters.searchCondition.isSearch ? true : false
    this.isAllList(status)
  },

  methods: {
    getNeedDicts() {
      this.getDicts(Object.keys(this.dictMap)).then((data) => {
        this.dictMap = Object.keys(this.dictMap).reduce((acc, dictType) => {
          acc[dictType] = data[dictType].reduce((map, { dictLabel, dictValue }) => {
            map[dictValue] = dictLabel;
            return map;
          }, {});
          return acc;
        }, {});
      });
    },
    // 切换今日/所有列表
    async isAllList(state) {
      this.allList = state;
      if (!state) {
        this.pagination.size = 8;
        this.commonBts1 = "commonbtn selectedbtn";
        this.commonBts2 = "commonbtn";
        this.enTitle1 = "english-title en-selected";
        this.enTitle2 = "english-title";
        this.ang1 = "ang1";
        this.ang2 = "ang2";
        const { total, ...params } = this.pagination;
        this.loading = true;
        req("/accident/getCarRescueList/today", "get", params)
          .then((res) => {
            console.log(res);
            this.tableData = res.data.list;
            this.pagination.total = res.data.total;
          })
          .catch((err) => {
            console.log(err);
          });
        this.loading = false;
      } else {
        this.pagination.size = 6;
        this.commonBts1 = "commonbtn";
        this.commonBts2 = "commonbtn selectedbtn";
        this.enTitle1 = "english-title";
        this.enTitle2 = "english-title en-selected";
        this.ang1 = "ang1-other";
        this.ang2 = "ang2-other";
        // this.getSearchTime();
        const { total, ...params } = this.pagination;
        this.loading = true;
        let condition = this.$store.getters.searchCondition.isSearch ? this.$store.getters.searchCondition.searchQuery : {}
        getCarRescueList(params,condition)
        .then(res => {
          console.log(res);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        })
        // let res2 = await getAccidentList({}, this.pagination);
        // this.tableData = res2.data.list;
        // this.pagination.total = res2.data.total;
        // console.log(res2);
        this.loading = false;
      }
    },
    // 去重query
    resetQuery() {
      let obj = {};
      Object.keys(this.query).forEach((key) => {
        if (this.query[key]) {
          obj[key] = this.query[key];
        }
      });
      return obj;
    },
    // 搜索
    async search() {
      console.log(this.query, 111);
      this.$store.commit("app/SET_SEARCHCONDITION", { searchQuery:this.query,current:1, isSearch: true})
      if (this.accidentDate.length > 0) {
        const [startTiem, endTime] = this.accidentDate;
        this.query.accidentStartDate = startTiem;
        this.query.accidentEndDate = endTime;
      }
      const { total, ...params } = this.pagination;
      this.pagination.page = 1;
      this.loading = true;
      const data = this.resetQuery();
      getCarRescueList(params, data)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
    // 重置
    async reset() {
      this.query = {
        accidentId: "",
        accidentStartDate: "",
        accidentEndDate: "",
      };
      // this.getSearchTime();
      this.loading = true;
      const { total, ...params } = this.pagination;
      getCarRescueList(params, this.resetQuery())
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 打开修车进度模态框
    openRepairModal(carMaintainStatus, id) {
      this.process1Checked = false
      this.process2Checked = false
      this.process3Checked = false
      this.process1Disabled = false
      this.process2Disabled = false
      this.process3Disabled = false
      this.repairProcessVisible = true;
      this.code1 = id;
      this.carMaintainStatus1 = carMaintainStatus;
      console.log(carMaintainStatus, "carMaintainStatus");
      if (carMaintainStatus === 0 || carMaintainStatus) {
        console.log(carMaintainStatus);
        switch (carMaintainStatus) {
          case 0:
            console.log("000");
            this.process1Checked = true;
            this.process2Checked = false;
            this.process3Checked = false;
            this.process1Disabled = true;
            this.process2Disabled = false;
            this.process3Disabled = true;
            break;
          case 1:
            console.log("111");
            this.process1Checked = true;
            this.process2Checked = true;
            this.process3Checked = false;
            this.process1Disabled = true;
            this.process2Disabled = true;
            this.process3Disabled = false;
            break;
          case 2:
            console.log("222");
            this.process1Checked = true;
            this.process2Checked = true;
            this.process3Checked = true;
            this.process1Disabled = true;
            this.process2Disabled = true;
            this.process3Disabled = true;
            break;
          default:
            this.process1Checked = false;
            this.process2Checked = false;
            this.process3Checked = false;
            this.process1Disabled = false;
            this.process2Disabled = true;
            this.process3Disabled = true;
            break;
        }
      } else {
        this.process1Checked = false;
        this.process2Checked = false;
        this.process3Checked = false;
        this.process1Disabled = false;
        this.process2Disabled = true;
        this.process3Disabled = true;
      }
    },
    // 关闭修车进度模态框
    processCancle() {
      this.repairProcessVisible = false;
      
    },
    // 提交修改
    processConfire() {
      this.repairProcessVisible = false;
      console.log(this.process1, this.process2, this.process3, "pro");
      switch (this.carMaintainStatus1) {
        case 0:
          if (this.process2) {
            this.updateProcess("1");
          }
          break;
        case 1:
          if (this.process3) {
            this.updateProcess("2");
          }
          break;
        case 2:
          break;
        default:
          if (this.process1) {
            this.updateProcess("0");
          }
          break;
      }
    },

    // 更新修车进度
    updateProcess(state) {
      req("/partyMaintenance/updateCarMaintainInfo", "get", {
        id: this.code1,
        carMaintainStatus: state,
      })
        .then((res) => {
          console.log(res);
          this.$message.success(res.msg);
          this.isAllList();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("提交失败,请重新提交!");
        });
    },

    // 切换当前页
    changeCurrentPage(pageInfo) {
      console.log(pageInfo);
      this.pagination.page = pageInfo.page
      this.$store.commit("app/SET_SEARCHCONDITION", { searchQuery:this.query,current:pageInfo.page, isSearch: true})
      const {total, ...params} = this.pagination
      const data = this.resetQuery()
      this.loading = true
      if(this.allList){
        getCarRescueList(params,data)
        .then(res => {
          console.log(res);
          this.tableData = res.data.list;
          this.pagination.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        })
      }else{
        req("/accident/getCarRescueList/today", 'get', params)
        .then(res => {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
        })
        .catch(err => {
          console.log(err);
        })
      }
      this.loading = false
    }

    // getFormTitle() {
    //   this.formKeys = Object.keys(this.source)
    //   this.formValues = Object.values(this.source)
    // }
  },
  created() {
    this.getNeedDicts();
    // this.getFormTitle();
  },
};
</script>
<style lang="less" scoped>
.operator-group {
  & > *:not(:last-child) {
    margin-right: 10px;
  }
}
.carAccidentListCom {
  position: relative;
  .ang1 {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 150;
  }
  .ang1-other {
    position: absolute;
    top: 0;
    left: 220px;
    z-index: 150;
  }
  .ang2 {
    position: absolute;
    top: 0px;
    left: 157px;
    z-index: 150;
  }
  .ang2-other {
    position: absolute;
    top: 0px;
    left: 377px;
    z-index: 150;
  }
  .ang2-2 {
    position: absolute;
    top: 78px;
    right: 0;
    z-index: 150;
  }
  .ang3 {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .ang4 {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  // .maincontent {
  //   height: 796px;
  // }
  .changlistbtns {
    width: 420px;
    height: 70px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .commonbtn {
      width: 200px;
      height: 68px;
      border: 1px solid #0084ff;
      color: #b1e3ff;
      font-size: 20px;
      margin-top: 13px;
      display: flex;
      flex-direction: column;
      text-align: center;
      background-image: linear-gradient(#0d2c60, #010345);
      cursor: pointer;
      .cn-title {
        margin-top: 13px;
      }
      .english-title {
        font-size: 12px;
        color: rgba(177, 227, 255, 0.6);
      }
      .title-selected {
        margin-top: 18px;
      }
      .en-selected {
        color: #0ebd35;
      }
    }
    .selectedbtn {
      height: 81px;
      margin-top: 0;
      color: #0ebd35;
      border-bottom: 1px solid #010345;
      z-index: 100;
    }
  }
  .listcontent {
    height: 740px;
    border: 1px solid #0084ff;
    padding-left: 20px;
    padding-right: 20px;
    background: rgba(15, 31, 70, 0.6);
    .statusbtns {
      width: 100%;
      height: 70px;
      // border: 1px solid #0084ff;
      .status1 {
        margin-top: 10px;
        width: 180px;
        height: 48px;
        border: 1px solid #0084ff;
        border-radius: 4px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        color: #b1e3ff;
        float: left;
        cursor: pointer;
      }
      .status2 {
        margin-top: 10px;
        width: 160px;
        height: 48px;
        border: 1px solid #0084ff;
        border-radius: 4px;
        margin-left: 10px;
        color: #b1e3ff;
        font-size: 20px;
        text-align: center;
        line-height: 48px;
        float: left;
        cursor: pointer;
      }
      .status-selected {
        border: 1px solid #0ebd35;
        background: url("../assets/images/list/status-selected.png") no-repeat top right;
        color: #0ebd35;
      }
    }
    .searchform {
      height: 170px;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #0084ff;
      .searchitem1 {
        width: 300px;
        margin-top: -10px;
        display: flex;
        flex-direction: column;
        .searchitem1-laber {
          margin-top: 20px;
          margin-bottom: 10px;
          font-size: 12px;
          color: #17ecfe;
        }
        .searchbtns {
          width: 400px;
          height: 36px;
          margin-top: 16px;
          .search-btn {
            border: 1px solid #0ebd35;
            color: #0ebd35;
            background-color: rgba(14, 189, 53, 0.1);
          }
          .reset-btn {
            background-color: rgba(0, 132, 255, 0.1);
            color: #b1e3ff;
            margin: 0 15px;
          }
          .more-btn {
            background-color: rgba(0, 132, 255, 0.1);
            color: #b1e3ff;
          }
        }
        .searchinput {
          // border: 1px solid #0084ff;
          background-color: transparent !important;
        }
        .el-input--medium .el-input__inner {
          // background-color: transparent;
          // color: #b1e3ff !important;
        }
      }
      .searchitem2 {
        width: 400px;
      }
    }
    // .el-table__empty-block {
    //   height: 500px!important;
    // }
  }
}
.processcontent {
  // width: 100%;
  height: 280px;
  position: relative;
  margin-left: 180px;
  .proBtns {
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    width: 340px;
    height: 48px;
    position: absolute;
    bottom: 0;
    .proCancle {
      cursor: pointer;
      width: 158px;
      height: 46px;
      border: 1px solid #0084ff;
      background: rgba(0, 132, 255, 0.1);
      font-size: 20px;
      line-height: 46px;
      text-align: center;
      color: #b1e3ff;
      border-radius: 4px;
    }
    .proConfire {
      cursor: pointer;
      width: 158px;
      height: 46px;
      border: 1px solid #0ebd35;
      background: rgba(14, 189, 53, 0.1);
      border-radius: 4px;
      font-size: 20px;
      line-height: 46px;
      text-align: center;
      color: #0ebd35;
    }
  }
}
.el-tabs__item,
.el-button--medium,
.el-radio__label,
.el-form-item__label,
.el-select-dropdown__item,
.el-button,
.el-checkbox__label,
.el-table,
.el-link {
  color: #17ecfe;
  font-size: 22px;
  // font-weight: bold;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #0ebd35;
  border-color: #0ebd35;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0ebd35;
  border-color: #0ebd35;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0ebd35;
}
</style>
